import { createAction } from '@ngrx/store';
import { paymentFormsFeatureKey } from './payment-forms.state';
import { BillingAddressForm } from '../../../models/payment-forms/billing-address-form';
import { BillingPhoneForm } from '../../../models/payment-forms/billing-phone-form';
import { PaymentInformationForm } from '../../../models/payment-forms/payment-information-form';
import { PaymentFormType } from '../../../models/payment-forms/payment-form-type';
import { TaxIdInformationDetail } from '../../../dtos/response/reservation-response/tax-id-information-detail';

/**
 * Resets the payment forms state
 */
export const initializePaymentFormsState = createAction(`[${paymentFormsFeatureKey}] Initialize payment forms state`);

/**
 * Sets the confirmation email form data
 */
export const setConfirmationEmailForm = createAction(`[${paymentFormsFeatureKey}] Set confirmation email form`, (email: string | null) => ({
  email,
}));

/**
 * Sets the refund confirmation email form data
 */
export const setRefundConfirmationEmailForm = createAction(
  `[${paymentFormsFeatureKey}] Set refund confirmation email form`,
  (email: string) => ({
    email,
  })
);

/**
 * Sets the refund atmos number form data
 */
export const setRefundAtmosNumberForm = createAction(`[${paymentFormsFeatureKey}] Set refund atmos number form`, (atmosNumber: string) => ({
  atmosNumber,
}));

/**
 * Sets the don't send confirmation email flag
 */
export const setDontSendConfirmationEmail = createAction(
  `[${paymentFormsFeatureKey}] Set don't send confirmation email`,
  (skipConfirmationEmail: boolean) => ({
    skipConfirmationEmail,
  })
);

/**
 * Sets the billing address form data
 */
export const setBillingAddressForm = createAction(
  `[${paymentFormsFeatureKey}] Set billing address form`,
  (billingAddress: BillingAddressForm | null) => ({ billingAddress })
);

/**
 * Sets the billing phone form data
 */
export const setBillingPhoneForm = createAction(`[${paymentFormsFeatureKey}] Set billing phone form`, (billingPhone: BillingPhoneForm) => ({
  billingPhone,
}));

/**
 * Sets the payment information form data
 */
export const setPaymentInformationForm = createAction(
  `[${paymentFormsFeatureKey}] Set payment information form`,
  (paymentInformation: PaymentInformationForm) => ({
    paymentInformation,
  })
);

/**
 * Sets the CyberSource transient token
 */
export const setCyberSourceTransientToken = createAction(
  `[${paymentFormsFeatureKey}] Set CyberSource transient token`,
  (cyberSourceTransientToken: string) => ({
    cyberSourceTransientToken,
  })
);

/**
 * Sets the CyberSource error flag
 */
export const setCyberSourceError = createAction(`[${paymentFormsFeatureKey}] Set CyberSource error`, (cyberSourceError: boolean) => ({
  cyberSourceError,
}));

/**
 * Sets the current payment type
 */
export const setCurrentPaymentType = createAction(
  `[${paymentFormsFeatureKey}] Set current payment type`,
  (paymentType: PaymentFormType) => ({
    paymentType,
  })
);

/**
 * Sets the current credit/refund type
 */
export const setCurrentCreditRefundType = createAction(
  `[${paymentFormsFeatureKey}] Set current credit refund type`,
  (creditRefundType: PaymentFormType) => ({
    creditRefundType,
  })
);

export const setAwardTransactionMPNumber = createAction(
  `[${paymentFormsFeatureKey}] Set Award Transaction Mileage Plan Number`,
  (mpNumber: string) => ({
    mpNumber,
  })
);

export const setTaxIdInformation = createAction(
  `[${paymentFormsFeatureKey}] Set tax ID information`,
  (taxIdInformation: TaxIdInformationDetail | null) => ({
    taxIdInformation,
  })
);

export const setTaxIdRequired = createAction(`[${paymentFormsFeatureKey}] Set tax ID required`, (taxIdRequired: boolean) => ({
  taxIdRequired,
}));
